export default "__VITE_ASSET__fff10d5e__"